import ticketTypes from './ticketTypes'
import noteTypes from './noteTypes'
import softwarePrograms from './softwarePrograms'
import roles from './roles'

/**
 * Göttfert's application settings
 */
export default {
  languages: ['en', 'de'],
  namespaces: [
    'admin',
    'team',
    'ticket',
  ],
  bannedMailDomains: [
    'goettfert', // banning all TLDs that contain 'goettfert'
  ],
  suppressPersistence: true,
  enableDevicesConfirmation: true,
  suppressProductDevices: true,
  showEquipmentPartsAvailable: true,
  suppressTicketFinishStepForRoles: ['Sales', 'CustomerServiceCooperator'],
  suppressTicketStopDialog: true,
  suppressExternalTeams: true,
  suppressedTicketFilters: ['submitterRole'],
  usePrimaryColorInChat: true,
  registerRequestTypes: ['technical_issue', 'other'],
  teamDefaultRoles: ['CustomerServiceAgent', 'CustomerServiceRepresentative'],
  ticketTypes,
  noteTypes,
  softwarePrograms,
  roles,
}
